
import Search from 'vux/src/components/search/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import Divider from 'vux/src/components/divider/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'


export default {
name: "OperationContent",
components: {Search, Grid, GridItem, Divider, Scroller},
props: {
operateType: String
},
methods: {
showModule() {
AlertModule.show({
title: '中心提示',
content: '确定选择中心？',
})
},
showModuleAuto() {
this.showModule()
setTimeout(() => {
AlertModule.hide()
}, 1500)
},
},
data() {
return {operation: {store_no: '1'}}
}
}



// WEBPACK FOOTER //
// ./src/components/page2/OperationContent.vue